import React from "react";
import { Toolbar as RhombusToolbar, Button, Icon } from "rhombus-react";
import { Link } from "react-router-dom";
import { openModal } from "reducers/Modal";
import { MODAL_TYPES } from "utils/constants";
import { useDispatch } from "react-redux";
import { confirmDeleteQrDesign } from "reducers/Confirm";
import { replace } from "connected-react-router";
import Permissioned from "widgets/Permissioned";

import "./QrCodesGrid.css";

export default function Toolbar({ designId, designName, libraryId, numQrCodes, searchTerm, handleSearch, onClearFilters }) {
	let dispatch = useDispatch();

	function openDuplicateQrCodeDesignModal(){
		dispatch(openModal(MODAL_TYPES.DUPLICATE_QR_CODE_DESIGN, {
			designId,
			libraryId,
			initialValues: { name: `${designName} Copy` } }
		));
	}

	function openDeleteQrCodeDesignModal() {
		dispatch(confirmDeleteQrDesign({
			id: designId,
			libraryId,
			designName,
			onSuccess: () => dispatch(replace(`/library/${libraryId}/qr-designs/`)),
		}));
	}

	const handleBackClick = () => {
		onClearFilters();
	};

	const searchProps = {
		placeholder: "Search",
	};

	return(
		<RhombusToolbar
			{...(numQrCodes > 0 && {
				search: true,
				searchProps,
				onSearch: handleSearch,
				searchValue: searchTerm,
			})}
			className="creative-search"
		>
			<div className="design-name-div" data-testid="design-name-header">
				<Link to={`/library/${libraryId}/qr-designs/`}  onClick={handleBackClick}>
					<Icon name="fa-arrow-left" iconStyle="fas" style={{ color: "#2d7ebf" }}  />
				</Link>
				<h4 className="design-name-toolbar" data-testid="design-name-heading">
					{designName}
				</h4>
			</div>
			<Permissioned action="Upload Assets" domain="Creative View">
				<>
					{designName && (<div className="button-side-codes" data-testid="toolbar-buttons">
						<Button
							icon="copy"
							style="block"
							theme="default"
							onClick={openDuplicateQrCodeDesignModal}
						>
							Duplicate
						</Button>
						{numQrCodes === 0 && (
							<Button
								icon="delete"
								style="block"
								theme="default"
								onClick={openDeleteQrCodeDesignModal}
							>
								Delete
							</Button>
						)}
					</div>)}
				</>
			</Permissioned>
		</RhombusToolbar>
	);
}

Toolbar.displayName = "QrCodesToolbar";
